import { useEffectAsync } from "./useEffectAsync";

export function useEventHandler(args: {
  name: string;
  handler: (event: any) => void;
}) {
  useEffectAsync({
    deps: [],
    async effect() {
      window.addEventListener(args.name, args.handler);
    },
    async cleanup() {
      window.removeEventListener(args.name, args.handler);
    },
  });
}
